import "./styles/quasar.scss";
import iconSet from "quasar/icon-set/fontawesome-v5.js";
import lang from "quasar/lang/es.js";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";
import Notify from 'quasar/src/plugins/notify/Notify.js';;

// To be used on app.use(Quasar, { ... })
export default {
  plugins: { Notify },
  config: {},
  lang: lang,
  iconSet: iconSet,
};
